export default __webpack_public_path__ + "static/media/TextDiff.22919f77.less";